import type { QueryClient } from "@tanstack/react-query";

import { coachStatusQueryOptions } from "~/lib/queries/coachStatusQuery";

/**
 * Whether she gets the coach account settings page: she is a coach. A failed
 * read answers no, which leaves her on the profile settings every account
 * has.
 */
export async function hasCoachAccountSettings(
  queryClient: QueryClient,
  clerkUserId: string,
): Promise<boolean> {
  const coachStatus = await queryClient
    .fetchQuery(coachStatusQueryOptions(clerkUserId))
    .catch(() => null);
  return coachStatus?.isCoach === true;
}
